import { Button } from '@custom/dx3';
import { type MouseEvent, useCallback, useState } from 'react';
import { HeartFilledIcon, HeartIcon } from '../assets/svgs/index.js';
import { usNumberFormatter } from '../utils/formatters.js';
import { logError } from '../utils/logError.js';

export function LikeButton({
  iLike,
  onChange,
  totalLikes,
}: {
  iLike: boolean;
  onChange: (like: boolean) => Promise<void>;
  totalLikes: number;
}): JSX.Element {
  const [updating, setUpdating] = useState(false);

  const handleClickLike = useCallback(
    (evt: MouseEvent) => {
      evt.preventDefault();
      evt.stopPropagation();
      setUpdating(true);
      onChange(!iLike)
        .catch(logError)
        .finally(() => setUpdating(false));
    },
    [iLike, onChange]
  );

  const label = `${
    totalLikes ?? 0
  } people have favorited this mission, click to ${
    iLike ? 'un-favorite' : 'favorite'
  }`;

  return (
    <Button
      aria-label={label}
      className="favorite"
      disabled={updating}
      onClick={handleClickLike}
      size="small"
      startIcon={
        <div style={{ color: 'var(--color-red)', display: 'grid' }}>
          <HeartIcon style={{ gridArea: '1/1/1/1' }} />
          <HeartFilledIcon
            style={{
              gridArea: '1/1/1/1',
              opacity: iLike ? 1 : 0,
              transform: `scale(${iLike ? 1 : 0})`,
              transformOrigin: '50% 50%',
              transition: 'opacity 500ms, transform 500ms',
            }}
          />
        </div>
      }
      style={{ minWidth: 0 }}
    >
      {usNumberFormatter.format(totalLikes ?? 0)}
    </Button>
  );
}
